import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";

// Registrar la fuente Montserrat
Font.register({
  family: "Montserrat",
  src: "/fonts/Montserrat-Regular.ttf", // Ruta a la fuente Montserrat
  fonts: [
    { src: "/fonts/Montserrat-Regular.ttf", fontWeight: "normal" },
    { src: "/fonts/Montserrat-Bold.ttf", fontWeight: "bold" },
  ],
});

const AcusePDF = ({ cita }) => (
  <Document>
    <Page style={styles.page}>
      {/* Encabezado */}
      <View style={styles.imgConHeader}>
        <Image src={"/images/logos/brigadaVino.png"} style={styles.img} />
        <Image src={"/images/logos/gobierno.png"} style={styles.img} />
        <Image src={"/images/logos/of.png"} style={styles.img} />
        <Image src={"/images/logos/salud.png"} style={styles.img} />
        <Image src={"/images/logos/SSH.png"} style={styles.img2} />
      </View>

      {/* Datos del paciente */}
      <View style={styles.section}>
        <Text style={styles.title}>
          Formulario de Triage para asignación de pacientes a especialidades
        </Text>
      </View>
      <View style={styles.divider}></View>
      <Text style={styles.contentText}>Datos del paciente</Text>
      <View style={styles.gridContainer}>
        <View style={styles.gridItem6}>
          <Text style={styles.gridText2}>
            Nombre:{" "}
            <Text style={styles.textSubrayado}>
              {cita?.nombre ?? "No especificado"}
            </Text>
          </Text>
        </View>
      </View>
      <View style={styles.gridContainer}>
        <View style={styles.gridItem6}>
          <Text style={styles.gridText2}>
            Edad:{" "}
            <Text style={styles.textSubrayado}>
              {cita?.edad ?? "No especificado"}
            </Text>
          </Text>
        </View>
      </View>
      <View style={styles.gridContainer}>
        <View style={styles.gridItem6}>
          <Text style={styles.gridText2}>
            Sexo:{" "}
            <Text style={styles.textSubrayado}>
              {cita?.sexo ? cita?.sexo : "No especificado"}
            </Text>
          </Text>
        </View>
      </View>

      {/* Signos vitales */}
      <View style={styles.divider}></View>
      <Text style={styles.contentText}>Signos vitales</Text>
      <View style={styles.gridContainer}>
        <View style={styles.gridItem6}>
          <Text style={styles.gridText2}>
            Peso:{" "}
            <Text style={styles.textSubrayado}>
              {cita?.consultas[0]?.peso ?? "No especificado"} kg
            </Text>
            Talla:{" "}
            <Text
              style={{
                ...styles.textSubrayado,
                marginLeft: 10,
              }}
            >
              {cita?.consultas[0]?.talla ?? "No especificado"} cm
            </Text>
          </Text>
        </View>
        <View style={styles.gridItem6}>
          <Text style={styles.gridText2}>
            Temperatura:{" "}
            <Text style={styles.textSubrayado}>
              {cita?.consultas[0]?.temperatura ?? "No especificado"} °C
            </Text>
          </Text>
        </View>
      </View>
      <View style={styles.gridContainer}>
        <View style={styles.gridItem6}>
          <Text style={styles.gridText2}>
            Frecuencia Cardíaca:{" "}
            <Text style={styles.textSubrayado}>
              {cita?.consultas[0]?.frecuenciaCardiaca ?? "No especificado"} LPM
            </Text>
          </Text>
        </View>
        <View style={styles.gridItem6}>
          <Text style={styles.gridText2}>
            Saturación de Oxigeno:{" "}
            <Text style={styles.textSubrayado}>
              {cita?.consultas[0]?.saturacionCo2 ?? "No especificado"}%
            </Text>
          </Text>
        </View>
      </View>
      <View style={styles.gridContainer}>
        <View style={styles.gridItem6}>
          <Text style={styles.gridText2}>
            Frecuencia Respiratoria:{" "}
            <Text style={styles.textSubrayado}>
              {cita?.consultas[0]?.frecuenciaRespiratoria ?? "No especificado"}{" "}
              RPM
            </Text>
          </Text>
        </View>
        <View style={styles.gridItem6}>
          <Text style={styles.gridText2}>
            Perímetro Abdominal:{" "}
            <Text style={styles.textSubrayado}>
              {cita?.consultas[0]?.perimetroAbdominal ?? "No especificado"}{" "}
            </Text>
          </Text>
        </View>
      </View>
      <View style={styles.gridContainer}>
        <View style={styles.gridItem6}>
          <Text style={styles.gridText2}>
            Presión Arterial:{" "}
            <Text style={styles.textSubrayado}>
              {cita?.consultas[0]?.presionArterialUno +
                "/" +
                cita?.consultas[0]?.presionArterialDos}{" "}
              mmHg
            </Text>
          </Text>
        </View>
        <View style={styles.gridItem6}>
          <Text style={styles.gridText2}>
            <Text style={styles.textSubrayado}>
              Glucosa: {cita?.consultas[0]?.glucosa ?? "No especificado"} mg/dL
            </Text>
          </Text>
        </View>
      </View>

      {/* TRIAGE */}
      <View style={styles.divider}></View>
      <Text style={styles.contentText}>Triage</Text>
      <View style={styles.gridContainer}>
        <View style={styles.gridItem6}>
          <Text style={styles.gridText2}>
            Motivo de consulta:{" "}
            <Text style={styles.textSubrayado}>
              {cita?.consultas[0]?.motivo ?? "No especificado"}
            </Text>
          </Text>
        </View>
      </View>

      {/* Destino del paciente */}
      <View style={styles.divider}></View>
      <Text style={styles.contentText}>Destino del paciente</Text>
      <View style={styles.gridContainer}>
        <View style={styles.gridItem6}>
          <Text style={styles.gridText2}>
            Especialidad Asignada:{" "}
            <Text style={styles.textSubrayado}>
              {cita?.consultas[0]?.especialidad?.nombre ?? "No especificado"}
            </Text>
          </Text>
        </View>
      </View>
      <View style={styles.gridContainer}>
        <View style={styles.gridItem6}>
          <Text style={styles.gridText2}>
            Médico Responsable:{" "}
            <Text style={styles.textSubrayado}>
              {cita?.consultas[0]?.doctor?.nombre ?? "No especificado"}
            </Text>
          </Text>
        </View>
      </View>
      <View style={styles.gridContainer}>
        <View style={styles.gridItem6}>
          <Text style={styles.gridText2}>
            Observaciones:{" "}
            <Text style={styles.textSubrayado}>
              {cita?.consultas[0]?.observaciones ?? "No especificado"}
            </Text>
          </Text>
        </View>
      </View>

      {/* Firma del medico */}
      <View style={styles.divider}></View>
      <Text style={styles.contentText}>Firma del médico</Text>
      <View style={styles.gridContainer}>
        <View style={styles.gridItem6}>
          <Text style={styles.gridText2}>
            Nombre:{" "}
            <Text style={styles.textSubrayado}>
              {cita?.consultas[0]?.doctor?.nombre ?? "No especificado"}
            </Text>
          </Text>
        </View>
      </View>

      {/* NOTA MEDICA */}

      <View style={styles.divider}></View>
      <Text style={styles.contentText}>Médico que refiere:</Text>

      <View style={{ marginBottom: 20 }}></View>
      <Text style={styles.contentText}>Nota Médica</Text>
      <View style={styles.gridContainer}>
        <View style={styles.gridItem6}>
          <Text style={styles.textSubrayado}>
            {cita?.consultas[0]?.notaMedica ?? "No especificado"}
          </Text>
        </View>
      </View>
      <View style={{ marginBottom: 20 }}></View>
      {/*INDICACIONES MEDICAS*/}
      <Text style={styles.contentText}>Indicaiones Médicas</Text>
      <View style={styles.gridContainer}>
        <View style={styles.gridItem6}>
          <Text style={styles.textSubrayado}>
            {cita?.consultas[0]?.indicaciones ?? "No especificado"}
          </Text>
        </View>
      </View>
    </Page>
  </Document>
);

export default AcusePDF;

// Definir estilos
const styles = StyleSheet.create({
  page: {
    paddingVertical: 20,
    paddingHorizontal: 50,
    fontFamily: "Montserrat", // Cambiar la fuente a Montserrat
    backgroundColor: "#fff",
  },
  header: {
    fontSize: 20,
    textAlign: "center",
    marginBottom: 20,
    fontWeight: "bold",
    color: "#6a0d3a",
  },
  section: {},
  boxCita: {
    backgroundColor: "#f0f0f0",
    borderRadius: 10,
    padding: 10,
    width: "100%",
    marginBottom: 20,
  },
  title: {
    textAlign: "justify",
    fontSize: 15,
    fontWeight: "bold",
    textTransform: "uppercase",
    width: "100%",
  },
  divider: {
    backgroundColor: "#6a0d3a",
    height: 10,
    width: "100%",
    marginVertical: 10,
  },
  contentText: {
    fontSize: 12,
    textAlign: "left",
    color: "#000",
    fontWeight: 900,
  },
  infoText: {
    fontSize: 12,
    textAlign: "left",
    marginBottom: 5,
    color: "#000",
  },
  footer: {
    fontSize: 10,
    textAlign: "left",
    marginTop: 20,
    fontWeight: 700,
    color: "#000",
  },
  img: {
    width: 100,
    height: "auto",
  },
  img2: {
    width: 50,
    height: "auto",
  },
  imgConHeader: {
    width: "100%",
    height: "auto",
    marginBottom: 20,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
  },
  boxGris: {
    backgroundColor: "#f0f0f0",
    borderRadius: 10,
    padding: 10,
    width: "100%",
    marginBottom: 20,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  gridContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  gridItem6: {
    width: "48%",
  },
  gridItem6I: {
    width: "48%",
    textAlign: "right",
  },
  gridText: {
    color: "#000",
    fontSize: 13,
    fontWeight: "bold",
    marginBottom: 5,
  },
  textSubrayado: {
    color: "#000",
    fontSize: 11,
    textDecoration: "underline",
  },
  gridText2: {
    color: "#000",
    fontSize: 11,
    marginVertical: 2,
  },
  boldText: {
    fontWeight: "bold",
    color: "#000",
    fontSize: 12,
  },
});
